"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_PREMIUM_CONSULTING = exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_MONTHLY = exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = exports.ADDON_API = exports.ADDON_CUSTOM_SSL = exports.ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_DEDICATED_IP = exports.ADDON_ADS = exports.ADDON_REPORTING = exports.ADDON_CMS = exports.ADDON_BRAND_DOMAIN = exports.ENTERPRISE_SUITE_ONBOARDING = exports.PROFESSIONAL_SUITE_ONBOARDING = exports.HSFS_SETUP = exports.QUICK_START_CONSULTATION = exports.ADDITIONAL_USERS = exports.ADDITIONAL_CONTACTS = exports.SERVICE_ENTERPRISE_ONBOARDING = exports.SERVICE_ENTERPRISE = exports.SERVICE_PROFESSIONAL = exports.SERVICE_STARTER = exports.SALES_ENTERPRISE_ONBOARDING = exports.SALES_ENTERPRISE = exports.SALES_PROFESSIONAL = exports.SALES_STARTER = exports.MARKETING_ENTERPRISE_ONBOARDING = exports.MARKETING_ENTERPRISE = exports.MARKETING_PROFESSIONAL_ONBOARDING = exports.MARKETING_PROFESSIONAL = exports.MARKETING_STARTER = void 0;
var MARKETING_STARTER = 'marketingStarter';
exports.MARKETING_STARTER = MARKETING_STARTER;
var MARKETING_PROFESSIONAL = 'marketingProfessional';
exports.MARKETING_PROFESSIONAL = MARKETING_PROFESSIONAL;
var MARKETING_PROFESSIONAL_ONBOARDING = 'marketingProfessionalOnboarding';
exports.MARKETING_PROFESSIONAL_ONBOARDING = MARKETING_PROFESSIONAL_ONBOARDING;
var MARKETING_ENTERPRISE = 'marketingEnterprise';
exports.MARKETING_ENTERPRISE = MARKETING_ENTERPRISE;
var MARKETING_ENTERPRISE_ONBOARDING = 'marketingEnterpriseOnboarding';
exports.MARKETING_ENTERPRISE_ONBOARDING = MARKETING_ENTERPRISE_ONBOARDING;
var SALES_STARTER = 'salesStarter';
exports.SALES_STARTER = SALES_STARTER;
var SALES_PROFESSIONAL = 'salesProfessional';
exports.SALES_PROFESSIONAL = SALES_PROFESSIONAL;
var SALES_ENTERPRISE = 'salesEnterprise';
exports.SALES_ENTERPRISE = SALES_ENTERPRISE;
var SALES_ENTERPRISE_ONBOARDING = 'salesEnterpriseOnboarding';
exports.SALES_ENTERPRISE_ONBOARDING = SALES_ENTERPRISE_ONBOARDING;
var SERVICE_STARTER = 'serviceStarter';
exports.SERVICE_STARTER = SERVICE_STARTER;
var SERVICE_PROFESSIONAL = 'serviceProfessional';
exports.SERVICE_PROFESSIONAL = SERVICE_PROFESSIONAL;
var SERVICE_ENTERPRISE = 'serviceEnterprise';
exports.SERVICE_ENTERPRISE = SERVICE_ENTERPRISE;
var SERVICE_ENTERPRISE_ONBOARDING = 'serviceEnterpriseOnboarding';
exports.SERVICE_ENTERPRISE_ONBOARDING = SERVICE_ENTERPRISE_ONBOARDING;
var ADDITIONAL_CONTACTS = 'additionalContacts';
exports.ADDITIONAL_CONTACTS = ADDITIONAL_CONTACTS;
var ADDITIONAL_USERS = 'additionalUsers';
exports.ADDITIONAL_USERS = ADDITIONAL_USERS;
var QUICK_START_CONSULTATION = 'quickStartConsultation';
exports.QUICK_START_CONSULTATION = QUICK_START_CONSULTATION;
var HSFS_SETUP = 'hsfsSetup';
exports.HSFS_SETUP = HSFS_SETUP;
var PROFESSIONAL_SUITE_ONBOARDING = 'professionalSuiteOnboarding';
exports.PROFESSIONAL_SUITE_ONBOARDING = PROFESSIONAL_SUITE_ONBOARDING;
var ENTERPRISE_SUITE_ONBOARDING = 'enterpriseSuiteOnboarding';
exports.ENTERPRISE_SUITE_ONBOARDING = ENTERPRISE_SUITE_ONBOARDING;
var ADDON_BRAND_DOMAIN = 'addonBrandDomain';
exports.ADDON_BRAND_DOMAIN = ADDON_BRAND_DOMAIN;
var ADDON_CMS = 'addonCms';
exports.ADDON_CMS = ADDON_CMS;
var ADDON_REPORTING = 'addonReporting';
exports.ADDON_REPORTING = ADDON_REPORTING;
var ADDON_ADS = 'addonAds';
exports.ADDON_ADS = ADDON_ADS;
var ADDON_DEDICATED_IP = 'addonDedicatedIp';
exports.ADDON_DEDICATED_IP = ADDON_DEDICATED_IP;
var ADDON_TRANSACTIONAL_EMAIL = 'addonTransactionalEmail';
exports.ADDON_TRANSACTIONAL_EMAIL = ADDON_TRANSACTIONAL_EMAIL;
var ADDON_CUSTOM_SSL = 'addonCustomSsl';
exports.ADDON_CUSTOM_SSL = ADDON_CUSTOM_SSL;
var ADDON_API = 'addonApi';
exports.ADDON_API = ADDON_API;
var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 'serviceTrainingMarketingFundamentals';
exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = SERVICE_TRAINING_MARKETING_FUNDAMENTALS;
var SERVICE_INBOUND_CONSULTING_MONTHLY = 'serviceInboundConsultingMonthly';
exports.SERVICE_INBOUND_CONSULTING_MONTHLY = SERVICE_INBOUND_CONSULTING_MONTHLY;
var SERVICE_INBOUND_CONSULTING_ONGOING = 'serviceInboundConsultingOngoing';
exports.SERVICE_INBOUND_CONSULTING_ONGOING = SERVICE_INBOUND_CONSULTING_ONGOING;
var SERVICE_TECHNICAL_CONSULTING_ONGOING = 'serviceTechnicalConsultingOngoing';
exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = SERVICE_TECHNICAL_CONSULTING_ONGOING;
var SERVICE_PREMIUM_CONSULTING = 'servicePremiumConsulting';
exports.SERVICE_PREMIUM_CONSULTING = SERVICE_PREMIUM_CONSULTING;